import { Type } from '@angular/core';
import { HandleEmailVerifiedService } from '@examdojo/auth';
import { SaveLastUsedAuthEffect } from '../auth/save-last-used-auth.effect';
import { ChallengeActivityRealtimeService } from '../features/exams/effects/challenge-activity-realtime.service';
import { SyncChallengeActivityStateService } from '../features/exams/effects/sync-challenge-activity-state.service';
import { AssessmentEffectService } from './assessment-effect.service';
import { ExamDatesEffectService } from './exam-dates-effect.service';
import { FetchCategoryBoundariesOnSyllabusContextChangeEffectService } from './fetch-category-boundaries-on-syllabus-context-change-effect.service';
import { FetchCoursesOnProgramChangeService } from './fetch-courses-on-program-change.service';
import { FetchStreaksOnTimezoneChangeService } from './fetch-streaks-on-timezone-change.service';
import { FetchAssignmentsOnSyllabusChangeEffectService } from './fetch-assignments-on-syllabus-change-effect.service';
import { ForceUpdateAppEffectService } from './force-update-app-effect.service';

import { PosthogUserTraitsService } from './posthog-user-traits.service';
import { PracticeActivityRealtimeService } from './practice-activity-realtime.service';
import { RedirectOnFatalError } from './redirect-on-fatal-error.service';
import { ResetOnboardingStepWhenOnboarded } from './reset-onboarding-step-when-onboarded.service';
import { SyncPracticeActivityStateService } from './sync-practice-activity-state.service';
import { UpdateUserMarksOnAttemptGradedService } from './update-user-marks-on-attempt-graded.service';

export const APP_EFFECTS: Array<Type<unknown>> = [
  PosthogUserTraitsService,
  FetchCategoryBoundariesOnSyllabusContextChangeEffectService,
  FetchAssignmentsOnSyllabusChangeEffectService,
  HandleEmailVerifiedService,
  SaveLastUsedAuthEffect,
  AssessmentEffectService,
  ExamDatesEffectService,
  PracticeActivityRealtimeService,
  ChallengeActivityRealtimeService,
  SyncPracticeActivityStateService,
  SyncChallengeActivityStateService,
  UpdateUserMarksOnAttemptGradedService,
  FetchStreaksOnTimezoneChangeService,
  RedirectOnFatalError,
  ResetOnboardingStepWhenOnboarded,
  ForceUpdateAppEffectService,
  FetchCoursesOnProgramChangeService,
];
